module.exports = __webpack_public_path__ + "static/assets/4cfbf8efa9e1872500f57d7330d07ba5.svg";